import { Button, Input } from "antd";
import { IoSearch } from "react-icons/io5";
import {  useSelector } from "react-redux";
import {  RootState } from "../../../store/store";
import { useState } from "react";
import ModalWrapper from "../../generic/modal";
import AddDids from "../../Form/Dids";
import { usePermissions } from "../../../hooks/permissions";
import { Did } from "../../../interfaces/Did.type";

const inputSearchStyle: React.CSSProperties = {
    borderRadius: "25px",
    border: "none",
};

const searchIconStyle: React.CSSProperties = {
    height: "20px",
    width: "20px",
    color: "#6b7280",
    cursor: "pointer",
};


const DidsHeader = ({
    setSearchInput,
}: {
    setSearchInput: Function;
}) => {
    const dids = useSelector((state: RootState) => state.dids);
    const { selectedAccount } = useSelector((state: RootState) => state.admin);
    
    const [addDid, setAddDid] = useState<boolean>(false);
    const [editData, setEditData] = useState<Did | null>(null);
    const { hasPermission, hasPermission2 } = usePermissions();

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchInput(e.target.value);
    };


    return (
        <div >
            {
                addDid && <ModalWrapper
                    setIsModalOpen={setAddDid}
                    isModalOpen={addDid}
                    title={editData ? "Edit Number" : "Add Number"}
                >
                    <AddDids selectedAccount={selectedAccount} editData={editData} setIsModal={setAddDid} />
                </ModalWrapper>
            }
            {(hasPermission("sms", "createDids:any") || hasPermission2("sms.dids.create", "system")) && <Button style={{ width: "100%", marginBottom: "10px" }} type="primary" onClick={() => {
                setEditData(null)
                setAddDid(true)
            }}>Add Number</Button>
            }

            {dids.filter((did) => did.account_id == selectedAccount).length > 1 &&
                <Input
                    onChange={handleSearch}
                    style={inputSearchStyle}
                    size="middle"
                    placeholder="Search"
                    prefix={<IoSearch style={searchIconStyle} />}
                />}
        </div>
    );
};

export default DidsHeader;
